import { render, staticRenderFns } from "./ProductFeedbackDetails.vue?vue&type=template&id=c9b862d4&"
import script from "./ProductFeedbackDetails.vue?vue&type=script&lang=js&"
export * from "./ProductFeedbackDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports